module.exports = __webpack_public_path__ + "img/fkImg.52ecad42.png";